import React from "react";
import { renderNode } from "../../../renderer";

export default function RepeatNode({ node, context = {}}: any) {
	const items =
			node?.props?.items || [];

	const itemName =
			node?.props?.item || "item";

	return (
			<>
				{items.map((value: any, index: number) => {

					const childContext = {
						...context,
						[itemName]: value,
						index,
					};

					return (
							<React.Fragment key={index}>
								{
									node.children?.map(
											(child: any, i: number) =>{
												return renderNode(
														child,
														i,
														childContext
												);
											}
									)
								}
							</React.Fragment>
					);
				})}
			</>
	);
}